import { CyraError } from "./errors";
import type { PartnerContactLifecycleTarget } from "./models";

const lifecycleTargets: Record<PartnerContactLifecycleTarget, true> = {
  ACTIVE: true,
  INACTIVE: true,
  ARCHIVED: true,
};

export function assertContactLifecycleTarget(
  value: unknown,
): asserts value is PartnerContactLifecycleTarget {
  if (typeof value !== "string" || !Object.hasOwn(lifecycleTargets, value)) {
    throw new CyraError({
      code: "VALIDATION_FAILED",
      message: "This contact state requires a separate controlled privacy workflow.",
      requestId: "client",
    });
  }
}
